import React from 'react';

function Button(props) {
  return (
    <a className='button' href={props.href || '#'} onClick={props.onClick || (() => {})}>{props.text}</a>
  );
}

export default Button;
